<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="分配集名称">
              <global-select
                @successCallBack="assignmentSetIdSCHandler"
                ref="assignmentSetNameGS"
                @change="handleVersionChange"
                :value.sync="queryParams.assignmentSetId"
                selectType="selectSearch"
                searchParam="inputString"
                requestApi="/mdm/mdmOrgSrAssignmentSets/selectList"
                :selectItem="{ value: 'selectedValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <template>
            <a-col :md="6" :sm="24">
              <a-form-item label="分配集说明">
                <a-input :disabled="false" v-model="queryParams.description"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemCode"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24" >
              <a-form-item label="项目组">
                <a-select mode="multiple" :max-tag-count="1" show-search option-filter-prop="children" v-model="queryParams.projectTeam" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="主型号">
                <a-input :disabled="false" v-model="queryParams.foldNumber"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="软货标签">
                <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.softGoodLabel" >
                  <a-select-option v-for="(item) in softGoodLabels" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="来源供应商">
                <global-select
                  :value.sync="queryParams.sourceSupplierId"
                  v-decorator="['supplierIdList']"
                  selectType="selectMultipleSearch"
                  :dropdown-match-select-width="false"
                  requestApi="/mdm/mdmOrgSupplier/supplierNameList"
                  :selectItem="{ value: 'selectedValue', label: 'realValue' }"
                  searchParam="supplierName"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="">

                <a-checkbox-group
                  v-model="cbValue"
                  name="checkboxgroup"
                  :options="plainOptions"
                  @change="onCGChange"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleOnSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createData.show()" type="primary" v-hasPermi="['mdm:mdmOrgSrAssignmentSets:add']">新建</a-button>
      <a-button @click="handleUpdate" :loading="commitLoading" type="primary" v-hasPermi="['mdm:mdmOrgSrAssignments:saveOrUpdateData']">同步更新</a-button>
      <a-button @click="$refs.exportTemplate.show(queryParams.assignmentSetId)" type="primary" v-hasPermi="['mdm:mdmOrgSrAssignments:export']">导出</a-button>
      <a-button @click="$refs.importData.show(queryParams.assignmentSetId)" type="primary" v-hasPermi="['mdm:mdmOrgSrAssignments:import']">导入</a-button>
      <a-button @click="$refs.downingTemplate.show(queryParams.assignmentSetId)" type="primary">导入模板</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="itemCode"
            :scroll="{ fixScreen: true, x: 1300 }"
            :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PRODUCT_SOURCE_RULES_LIST, // 表格方案配置唯一值
              }"
          >
            <span slot="operation" slot-scope="{ record,index }">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record,index)" v-hasPermi="['mdm:mdmOrgSrAssignments:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDeleteAlert(typeList, record)" v-hasPermi="['mdm:mdmOrgSrAssignments:remove']">删除</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <!-- 平均活动价 -->
            <template slot="allocationPercent" slot-scope="{ record }">
              <!-- <span v-if="!isEdit || currentId !== record.id">{{ record.allocationPercentAll?record.allocationPercentAll+'%':'' }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record.allocationPercentAll" size="small" /> -->
              <a @click="handleGoDetail(record)">{{ record.allocationPercentAll?record.allocationPercentAll+'%':'0%' }}</a>

            </template>
            <template slot="isStopFlag" slot-scope="{ record }">
              <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
            </template>
          </ls-api-table>
        </a-spin>
        <create-data
          ref="createData"
          :url="url"
          :sopDfcBasicDataId="queryParams.versionCode"
          @handle-success="handleOk"
        />
        <import-data-new
          ref="importData"
          :url="url"
          :sopDfcBasicDataId="queryParams.assignmentSetId"
          @handle-success="handleOk"
        />
        <import-data-new
          ref="importData"
          :url="url"
          :sopDfcBasicDataId="queryParams.assignmentSetId"
          @handle-success="handleOk"
        />
        <downing-template
          ref="downingTemplate"
          :url="url"
          :sopDfcBasicDataId="queryParams.assignmentSetId"
          @handle-success="handleOk"
        />
        <export-template
          ref="exportTemplate"
          :url="url"
          :sopDfcBasicDataId="queryParams.assignmentSetId"
          @export-confirm="handleExportConfirm"
          @handle-success="handleOk">

        </export-template>
        <download-modal :apiFun="apiExportScpMpsDistributionRatio" ref="download" />
      </div>
    </template>
  </ls-table-layout>
</template>

    <script>
    import { generateLsTableResData } from '@/utils/util.js';
    import CreateData from './components/CreateData'
    import ImportData from './components/ImportData'
    import ImportDataNew from './components/ImportDataNew'
    import DowningTemplate from './components/DowningTemplate'
    import ExportTemplate from './components/ExportTemplate'
    import DownloadModal from '@/views/components/download-modal/download-modal.vue'
    import { apiScpMrpSrAssignmentSetsList, apiUpdateMdmOrgSrAssignmentSets, apiChangeMdmOrgSrAssignments, apiDelMdmOrgSrAssignments, apiExportScpMpsDistributionRatio } from '@/api/mps/basic-data/product-distribution-ratio.js';
    import { apiScpSopMpsOptionsList } from '@/api/mps/basic-data/mps-option.js';
    export default {
      // eslint-disable-next-line
      name: 'Product-source-rules',
      components: {
        CreateData,
        ImportData,
        ImportDataNew,
        DowningTemplate,
        ExportTemplate,
        DownloadModal
      },
      data () {
        return {
          apiExportScpMpsDistributionRatio,
          plainOptions: ['当前有效', '分配比例非100%'],
          cbValue: [],
          softGoodLabels: [], // 软货标签
          projectTeams: [], // 项目组
          commitLoading: false,
          versionCode: '',
          monthStart: '',
          monthEnd: '',
          url: '/mdm/mdmOrgSrAssignments/import',
          supplyTypeOptions: [],
          orderTypeOptions: [],
        classifyOptions: [],
          monthColumns: [],
          isSetTitle: false,
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(apiScpMrpSrAssignmentSetsList, true),
            pageCurrent: true
          },
          isEdit: false,
          currentId: "",
          // 控制搜索展开
          advanced: true,
          isLoading: false,
          // 查询参数
          queryParams: {
            notFullFlag: undefined,
            effectiveFlag: undefined,
            sourceSupplierId: undefined,
            softGoodLabel: undefined,
            foldNumber: undefined,
            projectTeam: undefined,
            assignmentSetId: undefined,
            description: undefined,
            itemCode: undefined
          },
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 状态快码
          statusOptions: [
            {
              dictLabel: "有效",
              dictValue: "Y"
            },
            {
              dictLabel: "无效",
              dictValue: "N"
            }
          ],
          baseUomFlagOptions: [
            {
              dictLabel: "是",
              dictValue: "Y"
            },
            {
              dictLabel: "否",
              dictValue: "N"
            }
          ],
          // 表格字段
          columnsNative: [
            {
              title: '物料编码',
              stickyFixed: 'left',
              width: 150,
              dataIndex: 'itemCode',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '物料名称',
              stickyFixed: 'left',
              ellipsis: true,
              dataIndex: 'itemName',
              width: 180,
              align: 'center'
            },
            {
              title: '规格描述',
              stickyFixed: 'left',
              ellipsis: true,
              dataIndex: 'specification',
              width: 220,
              align: 'left'
            },
            // {
            //   title: '来源组织',
            //   fixed: 'left',
            //   dataIndex: 'sourceOrganizationName',
            //   ellipsis: true,
            //   width: 100,
            //   align: 'center'
            // },
            // {
            //   title: '来源供应商',
            //   fixed: 'left',
            //   dataIndex: 'sourceSupplierName',
            //   ellipsis: true,
            //   width: 100,
            //   align: 'center'
            // },
            {
              title: '当月分配比例',
              stickyFixed: 'left',
              dataIndex: 'allocationPercentAll',
              scopedSlots: { customRender: 'allocationPercent' },
              width: 120,
              align: 'center'
            },
            {
              title: '下单类别',
              dataIndex: 'orderType',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '项目组',
              dataIndex: 'projectTeam',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '商品类别',
              dataIndex: 'productCategory',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '销售类目',
              dataIndex: 'salesCategory',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '主型号',
              dataIndex: 'foldNumber',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '软货标签',
              dataIndex: 'softGoodLabelDesc',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            // {
            //   title: '生效日期',
            //   dataIndex: 'startDateActive',
            //   ellipsis: true,
            //   width: 240,
            //   align: 'center'
            // },
            // {
            //   title: '失效日期',
            //   dataIndex: 'endDateActive',
            //   ellipsis: true,
            //   width: 240,
            //   align: 'center'
            // },
            {
              title: '创建人',
              dataIndex: 'createName',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '创建时间',
              dataIndex: 'createTime',
              scopedSlots: { customRender: 'createTime' },
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '最后修改人',
              dataIndex: 'updateName',
              ellipsis: true,
              width: 240,
              align: 'center'
            },
            {
              title: '最后修改时间',
              dataIndex: 'updateTime',
              scopedSlots: { customRender: 'updateTime' },
              ellipsis: true,
              width: 240,
              align: 'center'
            }
            // ,
            //   {
            //   title: '操作',
            //   width: 100,
            //   fixed: 'right',
            //   align: 'center',
            //   dataIndex: 'operation',
            //   scopedSlots: { customRender: 'operation' }
            //   }
          ],
          columns: [],
          unitOfMeasureList: [],
          unitOfMeasureListNew: []
        }
      },
      created () {
        this.columns = this.columnsNative
        this.queryParams.assignmentSetId = this.$route.query.assignmentSetId

        // this.queryParams.forecastName = this.$route.params.forecastName;
        // this.queryParams.versionCode = this.$route.params.versionCode;
        // this.versionCode = this.$route.params.versionCode;
        // this.monthEnd = this.$route.params.description;
        // this.monthStart = this.$route.params.id;
        const lookupQueryProjectTeamParams = {
            lookupType: 'SCP_PROJECT_TEAM',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryProjectTeamParams).then().then(response => {
        this.projectTeams = response.rows
        })
        const lookupQuerySoftGoodLabelParams = {
            lookupType: 'SCP_SOFT_GOOD_LABEL',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQuerySoftGoodLabelParams).then().then(response => {
        this.softGoodLabels = response.rows
        })
        this.initAssignmentSetId()
      },
      mounted () {
        // this.onSearch()
      },
      methods: {
        // 查询选项选中的分配集id
        initAssignmentSetId () {
          apiScpSopMpsOptionsList().then(response => {
            if (response.code === 200) {
              this.queryParams.assignmentSetId = response.data.assignmentSetId
              this.onSearch()
            }
          })
        },
        handleGoDetail (record) {
          this.$router.push({ path: `/product-source-rules/detail`, query: { itemId: record.itemId, assignmentSetId: record.assignmentSetId, itemCode: record.itemCode, sourceOrganization: record.sourceOrganization } })
        },
        onCGChange (checkedValues) {
          const self = this
          self.queryParams.effectiveFlag = undefined
          self.queryParams.notFullFlag = undefined
          checkedValues.forEach(function (value) {
          // 对每个值执行逻辑
          if (value === '当前有效') {
            self.queryParams.effectiveFlag = 'Y'
          }
          if (value === '分配比例非100%') {
            self.queryParams.notFullFlag = 'Y'
          }
        });
        },
        assignmentSetIdSCHandler (val) {
          // if (val) { this.queryParams.assignmentSetId = val[0].lookUpCode }
        },
              /** 下载模板操作 */
        handleTemplate () {
        this.download('scp/sopRatioLines/template', {
        }, `安全库存比例行导入模板_${new Date().getTime()}.xlsx`)
      },
        handleOnSearch () {
          this.isSetTitle = false
          this.onSearch()
        },
        handleInputChange (record, dataIndex) {

        },
        successCallBack (records) {
            // 遍历行数据
            for (let i = 0; i < records.length; i++) {
              const record = records[i]
              const detailVoList = records[i].detailVoList
              this.monthColumns = []
                for (let i = 0; i < detailVoList.length; i++) {
                  if (!self.isSetTitle) {
                      const title = detailVoList[i].month
                      this.monthColumns.push({
                        title: title,
                        dataIndex: `month${i}`,
                        width: 120,
                        align: 'center',
                        scopedSlots: { customRender: `month` }
                      })
                   }
                   // record[`month${i}`] = detailVoList[i].salesForecast
                   const propertyName = `month${i}`;
                    const propertyValue = detailVoList[i].salesForecast;
                    this.$set(record, propertyName, propertyValue);
              }

                if (!this.isSetTitle) { // 把数据插入到指定位置
                  // 使用扩展运算符
                  const columnsCopy = [...this.columnsNative];
                  columnsCopy.splice(9, 0, ...this.monthColumns);
                  this.columns = columnsCopy;
                }
                this.isSetTitle = true
            }
        },
        handleDeleteAlert (tableList, record) {
          const self = this
          this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            self.handleDelete(tableList, record)
          }
        })
        },
        handleDelete (tableList, record) {
          // const param = {
          //   itemId: record.itemId,
          //   versionCode: record.versionCode,
          //   lookupCode: record.lookupCode
          // }
          apiDelMdmOrgSrAssignments(record.id).then(response => {
          if (response.code === 200) {
            this.$message.success('删除成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
        },

        handleVersionChange (val, selectList) {
          if (val) {
            const filteredItem = selectList.filter(item => item.selectedValue === val);
            this.queryParams.description = filteredItem[0].realValue
          }
        },
        blur (record) {
          if (!record.conversionRate || Number(record.conversionRate) <= 0) {
            this.$message.warning('折换不能为空且需大于0')
          } else {
            record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
          }
        },
        statusOnChange (record) {
          record.status = record.status === 'Y' ? 'N' : 'Y'
        },
        // 导入导出excel
        /** 导出按钮操作 */
        handleExport () {
          this.download('mdm/mdmOrgSrAssignments/export', {
            ...this.queryParams
          }, `物料来源列表_${new Date().getTime()}.xlsx`)
        },
        // 编辑
        handleEdit (record, index) {
          if (this.currentId && record.id !== this.currentId && this.isEdit) {
            this.$message.warning('请保存上次编辑的数据')
            return;
          }
          this.isEdit = true;
          this.currentId = record.id;
        },
        // 编辑-保存
        handleSave (record) {
        // const recordCopy = JSON.parse(JSON.stringify(record));
        // const detailVoList = recordCopy.detailVoList
        // for (let i = 0; i < detailVoList.length; i++) {
        //    const detailVoItem = detailVoList[i]
        //    detailVoItem.salesForecast = recordCopy[`month${i}`]
        // }
        apiChangeMdmOrgSrAssignments(record).then(response => {
          if (response.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
        },
        handleUpdate () {
          if (!this.queryParams.assignmentSetId) {
            this.$message.error('请选择分配集名称')
            return
          }
          this.commitLoading = true
          apiUpdateMdmOrgSrAssignmentSets({ assignmentSetId: this.queryParams.assignmentSetId }).then(response => {
            this.commitLoading = false
          if (response.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        }).catch(e => {
        this.commitLoading = false
        this.$message.success('更新失败')
      })
        },
        // 取消
        handleCancel (record) {
          this.isEdit = false
          this.onSearch()
        },
        // 新增/修改框事件
        handleOk () {
          this.$refs.assignmentSetNameGS.handleSearch()
           this.onSearch()
        },
        // 表单搜索
        onSearch () {
          this.isEdit = false
         this.$refs.dataTable.searchParams = this.queryParams;
         this.$refs.dataTable.getData();
        // this.$refs.dataTable.myPagination.current = 1
        // this.getTableInfo({ sopDfcBasicDataId: this.id, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
        },
        /** 重置按钮操作 */
        resetQuery () {
          this.isSetTitle = false
          this.queryParams = {
            cbValue: [],
            notFullFlag: undefined,
            effectiveFlag: undefined,
            sourceSupplierId: undefined,
            softGoodLabel: undefined,
            foldNumber: undefined,
            projectTeam: undefined,
            assignmentSetId: this.queryParams.assignmentSetId,
            description: this.queryParams.description,
            itemCode: undefined
          }
          this.onSearch()
        },
        // 搜索框展开、收起
        toggleAdvanced () {
          this.advanced = !this.advanced
        },
        handleExportConfirm (params) {
          this.$refs.download.openModal(params)
        }
      }
    }
    </script>

    <style scoped lang="less">
    .ml10{
      margin-left: 10px;
    }
    </style>
